import React, { Fragment } from 'react';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './noDataFound.styles';

const NoDataFound = props => {
  return (
    <Fragment>
      <div className={css(styles.base, props.styles)}>
        <div className={css(styles.noDataRow)}> {I18n.t('data.noData')}</div>
      </div>
    </Fragment>
  );
};
export default NoDataFound;



// WEBPACK FOOTER //
// ./src/components/data/status/common/noDataFound.js